import * as React from 'react';
import Base, { Props as BaseProps } from '../Base/Base';
import { SidebarMenuContext } from './SidebarMenuContext';

const { useState } = React;

export interface Props extends BaseProps {
  /** Active flag that sets the visual state of the SidebarMenuItem and
   * also expands the SidebarSubMenu, if there is one included.
   */
  active: boolean;
}

/**
 * Child of the Sidebar component that should include exactly one SidebarMenuItem
 * and an optional SidebarSubMenu.
 */
const SidebarMenu: React.FunctionComponent<Props> = (props: Props) => {
  const { active, ...rest } = props;
  const [hasSubMenu, setHasSubMenu] = useState(false);

  return (
    <SidebarMenuContext.Provider value={ { active, hasSubMenu, setHasSubMenu } }>
      <Base { ...rest } className="Sidebar__menu" />
    </SidebarMenuContext.Provider>
  );
};

export default SidebarMenu;
